<template>
  <div class="step" :class="{ active, ready, disabled }" @click="onClickStepButton(stepNumber)">
    <span class="num">
      <span class="digit">{{ stepNumber }}</span>
    </span>
    <span class="step-name">
      <span>{{ stepName }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'FlowStep',
  props: {
    active: Boolean,
    ready: Boolean,
    stepNumber: Number,
    stepName: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickStepButton(event) {
      if (!this.disabled) {
        const data = event.toString();
        this.$emit('clicked', data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.step {
  background-image: url('../../assets/icons/bg_steps_icn_2@1x.svg');
  background-size: cover;

  &.step-1 {
    background-image: url('../../assets/icons/bg_steps_icn@1x.svg');
  }

  display: inline-block;

  &.active {
    cursor: pointer;
    .num {
      background-color: var(--btn-primary-bg);
    }
    color: var(--text-primary);
  }

  &.ready {
    cursor: pointer;
    .num {
      background-color: var(--btn-primary-bg);
    }
    color: var(--link-primary);
  }

  color: var(--link-primary);

  &.disabled {
    cursor: not-allowed;
  }

  .num {
    background-color: #b9c6d1;
    position: relative;
    top: rem(4);
    left: rem(4);

    .digit {
      padding-left: rem(6);
      bottom: rem(1);
      position: relative;
    }
  }

  .step-name {
    position: relative;
    top: rem(-27);
    left: rem(32);
    height: rem(39);
    width: rem(98);
    text-overflow: ellipsis;
    overflow: hidden;
    display: table;
    line-height: rem(14);
    padding-top: rem(3);
    span {
      display: table-cell;
      vertical-align: middle;
    }
  }

  width: rem(166);
  vertical-align: top;
  height: rem(57);
  background-color: var(--bg-primary);
  padding: $space-4 $space-4;
  background-size: rem(166);

  .num {
    color: white;
    border-radius: 50%;
    display: block;
    width: rem(20);
    height: rem(20);
  }
}
</style>
